const translations = {
  'accommodation.seo.title': 'Find Affordable TEFL Student Accommodation in Barcelona',
  'accommodation.seo.description': `TEFL Iberia helps our students find affordable accommodation in Barcelona, Spain. Find out more about how we can help you.`,
  'accommodation.sec1.title': 'Accommodation',
  'accommodation.sec1.description':
    'If the thought of moving to another city and negotiating with foreign landlords sounds stressful, don’t worry! We can provide you with <accent>comfortable, excellent-value accommodation</accent> within easy reach of the school. Our accommodation placement service is free and optional.',
};

export default translations;
